import React from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Card, CardContent, Box, Grid } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import { getRandomArbitrary } from '../../utils/Helpers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      minWidth: 180,
      height: '100%'
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(4)
    },
    title: {
      fontSize: '12pt',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      color: '#4B4B4B',
      fontWeight: 400
    }
  })
)

export default function ChartBarSkeleton (): JSX.Element {
  const classes = useStyles()

  const generatelist = (): JSX.Element[] => {
    const elements: JSX.Element[] = []

    for (let index = 0; index < 6; index++) {
      elements.push(<Box display="flex" alignItems="center" key={`chartbar-element-${index}`}>
        <Box width={280} className={classes.container}>
          <Skeleton height={32} width="100%" />
        </Box>
        <Box width={`${getRandomArbitrary(30, 80)}%`} className={classes.container}>
          <Skeleton width="100%" height={80}>
            <div style={{ paddingTop: '10%' }} />
          </Skeleton>
        </Box>
      </Box>)
    }

    return elements
  }

  return (
    <Card className={classes.root}>
      <Grid className={classes.container}>
        <CardContent>
          <Box width="100%">
            <Skeleton height={32} width="70%" />
          </Box>
          {generatelist()}
        </CardContent>
      </Grid>
    </Card>
  )
}
